export default "__VITE_ASSET__DiLPW5C1__"